import { jsx } from "react/jsx-runtime";
import AntAlert from "antd/es/alert";
import classnames from "../../utils/classnames.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import './Alert.css';/* empty css           */
const Alert = ({
  message,
  className,
  onClick,
  onClose,
  closable = true,
  type = "success",
  closeIcon = /* @__PURE__ */ jsx(Icon, { name: "cross" }),
  ...props
}) => {
  return /* @__PURE__ */ jsx(
    AntAlert,
    {
      type,
      onClick,
      onClose,
      closable,
      closeIcon,
      message: message ? /* @__PURE__ */ jsx(Typography.Paragraph, { level: "main", color: "lightest", children: message }) : null,
      className: classnames("perxis-auto-alert", className),
      ...props
    }
  );
};
export {
  Alert as default
};
//# sourceMappingURL=Alert.js.map
